<template>
  <v-btn-toggle color="primary" mandatory v-model="inBond">
    <v-btn :value="true" small>In-bond</v-btn>
    <v-btn :value="false" small>Duty-paid</v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'InBond',
  props: {
    value: {type:Boolean, required:false}
  },
  data() {
    return {
      inBond: null
    }
  },
  created() {
    this.inBond = this.value ?? (localStorage.getItem('inBond') == '1' || localStorage.getItem('inBond') == null);
    this.setInBond();
  },
  watch: {
    value() {
      this.inBond = this.value;
    },
    inBond() {
      this.setInBond();
      this.$emit('change', this.inBond);
    }
  },
  methods: {
    setInBond() {
      localStorage.setItem('inBond', this.inBond ? '1' : '0');
      this.$emit('input', this.inBond);
    }
  }
}
</script>